import { useEffect, useState } from "react";
import { Leaderboard } from "../components/LeaderBoard/LeaderBoard";
import { useAuth } from "../Context/AuthContext";
import {LeaderBoard as fetchLeaderBoardData, Read} from "../api/BingoCard";
import {Helmet} from "react-helmet-async";
import Modal from "../components/Modal/Modal";
import {RenderBingoCard} from "../components/BingoCard/BingoCard";
import {useNavigate} from "react-router-dom";


export default function LeaderboardPage() {
    const [leaderboardData, setLeaderBoardData] = useState({}); // Initialize as null to avoid issues before data loads

    const [cardData, setCardData] = useState(null);
    const { id } = useAuth();
    const navigate = useNavigate();

    /*useEffect(() => {
        if(selectedCard) {
            const fetchCard = async () => {
                const reponse = await Read(selectedCard);
                setCardData(reponse);

            }
            fetchCard();
        }
    }, [selectedCard]);*/

    useEffect(() => {
        const userid = id ?? -1;
        const fetchData = async () => {
            const response = await fetchLeaderBoardData(userid);
            console.log(response);
            setLeaderBoardData(response);

        };
        fetchData();
    }, [id]);


    const fetchBricks = async (id) => {
        try{
            const reponse = await Read(id);
            setCardData(reponse)

        }catch(err){

        }
    }


    return (
        <>
            <Helmet>
                <title>Leaderboard - GrandPrixBingo</title>
                <meta
                    name="description"
                    content="Check the GrandPrixBingo leaderboard and see how you rank among other F1 fans."
                />
                <meta
                    name="keywords"
                    content="F1 leaderboard, GrandPrixBingo, rankings, Formula 1"
                />
                <link rel="canonical" href="https://GrandPrixBingo.com/leaderboard" />
            </Helmet>
            <div style={containerStyle}>
                {leaderboardData.global && <Leaderboard data={leaderboardData.global} title="Worldwide" setCard={fetchBricks}/>}
                {leaderboardData.nation && id > 0 ? (
                    leaderboardData.nation.code ? (
                        <Leaderboard data={leaderboardData.nation} title="Nation" setCard={fetchBricks} />
                    ) : (<div className={"Block"} style={{width: "350px", height: "min-content", margin: "50px auto"}}>
                            <p>Add nationality to view the national leaderboard.</p>
                            <button onClick={()=>navigate("/profile")} style={{marginTop: "10px "}}>Edit Profile</button>
                        </div>
                    )
                ) : null}

            </div>
            {cardData && <Modal closeModal={()=>setCardData(null)}><RenderBingoCard card={cardData}/> </Modal>}
        </>
    );
}

const containerStyle = {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    gap: '20px',
    padding: '20px',
    width: '100%',
    boxSizing: 'border-box',
    flexWrap: 'wrap',
};
